// extracted by mini-css-extract-plugin
module.exports = {"container":"track-detail_container__HPpwy","title":"track-detail_title__SjrEc","info":"track-detail_info__G5IK4"};